import { Model } from 'modules/core/lib/mobx-rest'

interface A3nomConfigAttributes {
  id: string
  autonumbering_starts_on: number
  code_prefix: string
  company_id: string
}

class A3nomConfig extends Model<A3nomConfigAttributes> {
  static urlRoot() {
    return '/payroll_integrations/a3nom/configs'
  }
}

export default A3nomConfig
